import { LocalizedMessage } from '@services/requests/localizedMessagesService/interfaces';
import { Filter } from '@services/types';
import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

interface WhereParams {
  default_name?: Filter<string>;
  id?: Filter<string>;
  tnved_code?: Filter<string>;
  okved_code?: Filter<string>;
  _or?: WhereParams[];
  _and?: WhereParams[];
}

/**
 * Параметры для получения данных продуктов экосбора по фильтрам
 */
export interface EcoFeeProductsLoaderParams {
  limit?: number;
  offset?: number;
  where?: WhereParams;
}

export interface EcoFeeProductsLoaderResponse {
  items: {
    id: string;
    default_name: string;
    group_id: string;
    okved_code: string;
    tnved_code: string;
    localized_names: string[];
    localized_names_data: LocalizedMessage[];
    group: {
      group_type: 'packages' | 'products';
      id: string;
      name: string;
      number_group: string;
      rate_value: number;
      normative_value: number;
      coefficient: number;
    };
  }[];
}

/**
 * Запрос загрузки данных продуктов экосбора
 */
export class EcoFeeProductsLoaderQuery implements GraphQLQuery<EcoFeeProductsLoaderParams> {
  readonly query: any;

  readonly variables: EcoFeeProductsLoaderParams;

  constructor(params: EcoFeeProductsLoaderParams) {
    this.variables = {
      ...params,
    };
    this.query = gql`
      query EcoFeeProductsLoader(
        $limit: Int = 60
        $offset: Int = 0
        $where: product_gql_query_where_object
      ) {
        items: product_gql_list(
          limit: $limit
          offset: $offset
          where: $where
          order: [{ by: id, direction: desc, priority: 1 }]
        ) {
          id
          default_name
          group_id
          group {
            group_type
            id
            name
            number_group
            coefficient
            normative_value
            rate_value
          }
          tnved_code
          okved_code
          localized_names
        }
      }
    `;
  }
}
